import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from '../services/app.service';

@Pipe({
  name: 'filterCustom'
})
export class FilterCustomPipe implements PipeTransform {  
  
  constructor(
    private app: AppService
  ){

  }

  transform(items:any,dataItem:any):any {
    
    let orderBy = null;

    if(typeof(dataItem.order_by) != "undefined"){
      orderBy = dataItem.order_by;
    }
    
    if(orderBy == null){
      return items.filter((item) => this.applyFilter(item,dataItem)); 
    }else{
      
      items.filter((item) => this.applyFilter(item,dataItem));
      
      let _items = items.sort(function (a, b) {

        if(orderBy != 'news' && orderBy != 'top_sale'){
          if (a[orderBy] > b[orderBy]){   
            return 1;
          }
          if (a[orderBy] < b[orderBy]){  
            return -1; 
          }
        }else{

          if (a[orderBy] > b[orderBy]){  
            return -1;
          }
          if (a[orderBy] < b[orderBy]){  
            return 1; 
          }
          
        }
        // a must be equal to b
        return 0;
      });

      return _items;
    }

  }

  applyFilter(item,filter): boolean {
    
    let status = true;

    for (let field in filter) {
      //if (filter[field]) {
        if(field != "order_by" && field != "top_sale"){ 
          if (typeof filter[field] === 'string') {
            if (this.app.removerAcentos(item[field]).toString().toLowerCase().indexOf(this.app.removerAcentos(filter[field]).toString().toLowerCase()) === -1) {
              status = false;
              break;
            }
          } else if (typeof filter[field] === 'number') {
            if (item[field] !== filter[field]) {
              status = false;
              break;
            }
          }else if (typeof filter[field] === 'boolean'){
            if (item[field] !== filter[field]) {
              status = false;
              break;
            }
          }
        }
      //}
    }
    return status;
  }

}
